<div class="modal-header bg-primary text-white">
  <h5 class="modal-title">Measurement</h5>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div>
    <!-- Distance Container -->
    @if (getNumberOfPins() > 0) {
      <div class="distance-container">
        <table class="table table-striped table-hover custom-table">
          <tr class="fs-6">
            <th class="fw-light text-center text-white">Segment</th>
            <th class="fw-light text-center text-white">Distance</th>
            <th class="fw-light text-center text-white">Total</th>
            <th class="fw-light text-center text-white">
              Unit
              <select [(ngModel)]="selectedUnit" (change)="onUnitChange()" class="unit-select">
                @for (unit of units; track unit) {
                  <option [value]="unit">{{unit}}</option>
                }
              </select>
            </th>
          </tr>
          @for (seg of segmentInfo; track seg; let i = $index) {
            <tr>
              <td class="text-center">{{i + 1}}</td>
              <td class="text-center">{{seg.dist}}</td>
              <td class="text-center">{{seg.totalDist}}</td>
            </tr>
          }
        </table>
      </div>
    }

    <!-- Controls -->
    <div class="controls">
      @if (getNumberOfPins() > 0) {
        <button
          class="btn btn-success"
          (click)="clear()">
          Clear
        </button>
      }
    </div>

    <!-- Instructions -->
    <div>
      Click on map to measure distance between points.
    </div>
  </div>
</div>
